import React from 'react'
import { Breadcrumbs, BreadcrumbsItem, Link } from '@sainsburys-tech/fable'
import PropTypes from 'prop-types'
import { BreadcrumbEllipse } from './BreadcrumbEllipse'

const encode = text =>
  text
    .replace(/-/g, '%252D')
    .replace(/%20/g, '-')
    .replace(/%2B/g, '+')

export const Breadcrumb = ({ ancestors, brand, currentCategoryName }) => {
  const allAncestors = currentCategoryName
    ? [...ancestors, { id: 'current-category', name: currentCategoryName }]
    : ancestors

  const ancestorBreadcrumbsItems = allAncestors.map((ancestor, index) => {
    return (
      <li
        key={ancestor.id}
        itemProp='itemListElement'
        itemScope
        itemType='https://schema.org/ListItem'
        className='breadcrumb__item'
      >
        <BreadcrumbsItem href={ancestor.url} data-youreko='breadcrumb-category' itemProp='item'>
          <span itemProp='name'>{ancestor.name}</span>
          <meta itemProp='position' content={index + 1} />
        </BreadcrumbsItem>
      </li>
    )
  })

  return (
    <div className='breadcrumb'>
      <div className='breadcrumb__scroll-container'>
        <nav aria-label='Breadcrumb'>
          <ol itemScope itemType='https://schema.org/BreadcrumbList'>
            <Breadcrumbs colourScheme='dark' data-testid='breadcrumb-component' shouldShowCurrentPage={false}>
              {ancestorBreadcrumbsItems}
            </Breadcrumbs>
          </ol>
        </nav>
        {brand && (
          <div className='breadcrumb__shop-all'>
            <BreadcrumbEllipse className='breadcrumb__shop-all__separator' />
            <Link href={encode(`/sd/${encodeURIComponent(brand.toLowerCase())}/`)}>Shop all {brand}</Link>
          </div>
        )}
      </div>
    </div>
  )
}

Breadcrumb.propTypes = {
  ancestors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired,
  brand: PropTypes.string.isRequired,
  currentCategoryName: PropTypes.string
}
